import { action } from 'satcheljs';

const initializeSearch = action('initializeSearch');

export default initializeSearch;
